'use strict';

class ContactForm {
    constructor() {
        this.select = document.querySelector('#area');
        if (this.select !== null) {
            this.select.onchange = this.selectChange;
        }
        this.form = document.querySelector('#contact-form');
        if (this.form !== null) {
            this.form.addEventListener('submit', (event) => this.submitForm(event));
        }
    }
    selectChange(event) {
        const elements = document.querySelectorAll('.area__text');
        for (var i = 0; i < elements.length; i++) {
            if (window.getComputedStyle(elements[i], null).getPropertyValue("display") === 'block') {
                elements[i].style.display = 'none';
            }
        }

        const checkedOption = event.target.querySelector('option:checked');
        let id;
        if (checkedOption !== null) {
            const elem = document.querySelector(`.area__text[data-id="${checkedOption.value}"]`);
            if (elem !== null) {
                elem.style.display = 'block';
            }
        }

        if (event.target.value !== '') {
            event.target.style.color = '#fff';
            event.target.style.fontStyle = 'normal';
        } else {
            event.target.style.color = '#c8f2df';
           /* event.target.style.fontStyle = 'italic';*/
        }
    }
    submitForm(event) {
        event.preventDefault();
        const name = this.form.querySelector('#name').value;
        const email = this.form.querySelector('#email').value;
        const tel = this.form.querySelector('#tel').value;
        const select = this.form.querySelector('#area');
        const area = select.value;
        const areaText = select.querySelector('option:checked').textContent;
        const text = this.form.querySelector('#text').value;
        const timeStamp = this.form.querySelector('#timestamp').value;
        const sourceUri = this.form.querySelector('#sourceUri').value;
        const contentId = this.form.querySelector('#contentId').value;
        const submitButton = this.form.querySelector('button');
        const checksum = this.form.querySelector('#checksum').value;
        const uniquekey = this.form.querySelector('#uniquekey').value;
        const sentfromurl = this.form.querySelector('#sentfromurl').value;

        submitButton.classList.add('sending');
        submitButton.setAttribute('disabled','disabled');
        var headers = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'X-Requested-With': 'contact-form',
            'Content-Type': 'application/json'
        };
        fetch('/api/v1/message',
        {
            headers: headers,
            method: 'post',
            credentials: 'include',
            body: JSON.stringify({
                'timestamp': timeStamp,
                'name': name,
                'email': email,
                'tel': tel,
                'area': area,
                'areatext': areaText,
                'text': text,
                'contentId': contentId,
                'sourceUri': sourceUri,
                'checksum': checksum,
                'uniquekey': uniquekey,
                'sentfromurl': sentfromurl
            })
            }).then(resp => {
                if (resp.status === 403 || resp.status===500) {
                    submitButton.classList.remove('sending');
                    submitButton.removeAttribute('disabled');
                    const message = document.querySelector('.message--error');
                
                    if (resp.status === 403) {
                        resp.text().then(function (respMsg) {
                            message.querySelector('div p').innerHTML = respMsg;
                        });
                    }
                    else {
                        message.querySelector('div p').innerHTML = "Någonting gick fel. Prova att ladda om sidan och försök igen";
                    }
                    message.setAttribute('aria-live', 'rude');
                    message.style.bottom = '0';
                    setTimeout(() => {
                        message.style.bottom = '-300px';
                        message.removeAttribute('aria-live');
                    }, 10000);
            } else if (resp.status === 200) {
                submitButton.classList.remove('sending');
                submitButton.removeAttribute('disabled');
                const message = document.querySelector('.message--success');
                this.form.reset();
                message.setAttribute('aria-live', 'rude');
                message.style.bottom = '0';
                setTimeout(() => {
                    message.style.bottom = '-300px';
                    message.removeAttribute('aria-live');
                }, 5000);
            }
        });
        return false;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new ContactForm();
});




// WEBPACK FOOTER //
// ./Components/Shared/contactForm.js